import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ZealClientError } from "../../../AbstractApiClient/ZealClientError";
import {
  IPatchDepartmentsArgs,
  IPatchDepartmentsResponseData,
} from "./patchDepartments.schema";
import { ZealApiSuccessResponse } from "@zeal/common";

type SuccessResponse = ZealApiSuccessResponse<IPatchDepartmentsResponseData>;

export const patchDepartments = (axios: IAxiosInstance) => {
  return async (params: IPatchDepartmentsArgs) => {
    try {
      const { departmentID, ...body } = params;
      const response = await axios.noRetry.patch<SuccessResponse>(
        `/api/departments`,
        { departmentID, ...body }
      );
      return response?.data;
    } catch (e) {
      throw new ZealClientError(e);
    }
  };
};
